<template>
    <Transition name="popup-fade">
        <div v-if="visible" class="popup-overlay">
            <div class="remarks-popup p-8px">
                <div class="text-15px text-white font-500 text-center popup-title">Say hello～</div>
                <div class="text-12px text-white text-center absolute top-8px right-8px w-20px h-20px close-btn" @click="handleClose">
                    <img src="@/assets/images/chat/chatOpeningRemarksPopup/close.svg" alt="" class="w-full h-full">
                </div>
                <div>
                    <div v-for="(item, index) in props.recommendedReply?.slice(0, 3)" :key="item" class="" @click="handleSend(item)">
                        <div 
                            class="text-12px text-white text-center remarks-popup-item flex items-center"
                            :style="{ animationDelay: `${0.1 + index * 0.1}s` }"
                        >
                            <div class="flex-1 text-14px text-wrapper">
                                <div class="scrollable-text">
                                    {{ item }}
                                </div>
                                <div class="fade-mask"></div>
                            </div>
                            <div class="w-24px h-24px flex-shrink-0 ml-8px">
                                <img src="@/assets/images/chat/chatOpeningRemarksPopup/send.svg" alt=""
                                    class="w-full h-full">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Transition>
</template>
<script setup lang="ts">
import { useChatStore } from '@/stores/chat';
import { logEventSafe } from '@/plugins/firebase';
const chatStore = useChatStore();
const visible = defineModel<boolean>('visible', { required: true });
const props = defineProps<{
    recommendedReply: any[]
}>();
const emit = defineEmits(['handleSendMessage']);
const handleClose = () => {
    logEventSafe('select_reply_popup_click_close');
    chatStore.setIsShowOpeningRemarksPopup(true);
    visible.value = false;
}
const handleSend = (item: string) => {
    logEventSafe('select_reply_popup_click_send');
    emit('handleSendMessage', item);
    visible.value = false;
}
</script>
<style scoped lang="scss">
// 弹出动画
.popup-fade-enter-active {
    animation: popup-slide-up 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.popup-fade-leave-active {
    animation: popup-fade-out 0.3s ease-out;
}

@keyframes popup-slide-up {
    0% {
        opacity: 0;
        transform: translateY(30px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes popup-fade-out {
    0% {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
    100% {
        opacity: 0;
        transform: translateY(10px) scale(0.95);
    }
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    pointer-events: none;
}

.remarks-popup {
    position: fixed;
    bottom: 75px;
    left: 50%;
    transform: translateX(-50%);
    width: 305px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 20px 20px 15px 15px;
    backdrop-filter: blur(10px);
    z-index: 1000;
    pointer-events: auto;
    padding-bottom: 20px;
}

// 标题动画
.popup-title {
    animation: title-fade-in 0.4s ease-out 0.2s both;
    color: #01031B;
}

@keyframes title-fade-in {
    0% {
        opacity: 0;
        transform: translateY(-10px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

// 关闭按钮动画
.close-btn {
    animation: rotate-in 0.5s ease-out 0.3s both;
    cursor: pointer;
    transition: transform 0.2s ease;
    
    &:hover {
        transform: rotate(90deg) scale(1.1);
    }
    
    &:active {
        transform: rotate(90deg) scale(0.9);
    }
}

@keyframes rotate-in {
    0% {
        opacity: 0;
        transform: rotate(-180deg) scale(0);
    }
    100% {
        opacity: 1;
        transform: rotate(0deg) scale(1);
    }
}

// 列表项动画
.remarks-popup-item {
    margin-top: 2%;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 8px;
    // backdrop-filter: blur(10px);
    padding: 8px 12px;
    font-size: 14px;
    font-weight: 400;
    // color: #FFFFFF;
    color: #01031B;
    cursor: pointer;
    transition: all 0.3s ease;
    animation: item-slide-in 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) both;
    
    &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateX(5px);
    }
    
    &:active {
        transform: translateX(5px) scale(0.98);
    }
}

// 文本容器
.text-wrapper {
    position: relative;
    overflow: hidden;
}

// 可滚动文本
.scrollable-text {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    text-align: left;
    padding-right: 30px;
    
    // 文字淡出效果 - 使用 mask 实现
    -webkit-mask-image: linear-gradient(90deg, 
        rgba(0, 0, 0, 1) 0%, 
        rgba(0, 0, 0, 1) calc(100% - 40px), 
        rgba(0, 0, 0, 0) 100%
    );
    mask-image: linear-gradient(90deg, 
        rgba(0, 0, 0, 1) 0%, 
        rgba(0, 0, 0, 1) calc(100% - 40px), 
        rgba(0, 0, 0, 0) 100%
    );
    
    // 隐藏滚动条
    &::-webkit-scrollbar {
        display: none;
    }
    
    // 兼容火狐浏览器 - 隐藏滚动条
    scrollbar-width: none;
    
    // 兼容 IE/Edge
    -ms-overflow-style: none;
}

// 渐变淡出遮罩（备用方案 - 如果 mask 不生效）
.fade-mask {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 100%;
    background: linear-gradient(90deg, 
        transparent 0%, 
        rgba(255, 255, 255, 0.2) 100%
    );
    pointer-events: none;
    display: none; // 默认隐藏，mask 方案优先
}

@keyframes item-slide-in {
    0% {
        opacity: 0;
        transform: translateX(-30px);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}
</style>